import { useCallback, useState } from 'react';

/**
 * Owns the transcript keyboard-navigation index: -1 means navigation is not
 * engaged; otherwise the index of the active message. The raw setter is
 * exposed for the orchestrator's cross-concern moves (resetting on submit,
 * following an incoming bot answer) so that wiring stays visible at the
 * call site.
 */
export default function useTranscriptNavigation({
  focusComposerInput,
  messageCount,
}) {
  const [activeMessageIndex, setActiveMessageIndex] = useState(-1);

  const handleMessageNavMove = useCallback(
    nextIndex => {
      if (!messageCount) {
        return;
      }
      const boundedIndex = Math.max(0, Math.min(nextIndex, messageCount - 1));
      setActiveMessageIndex(boundedIndex);
    },
    [messageCount],
  );

  const handleTranscriptNavigationRequest = useCallback(() => {
    if (!messageCount) {
      return;
    }
    setActiveMessageIndex(messageCount - 1);
  }, [messageCount]);

  const handleExitMessageNavigation = useCallback(() => {
    setActiveMessageIndex(-1);
    focusComposerInput();
  }, [focusComposerInput]);

  return {
    activeMessageIndex,
    handleExitMessageNavigation,
    handleMessageNavMove,
    handleTranscriptNavigationRequest,
    setActiveMessageIndex,
  };
}
